document.addEventListener("DOMContentLoaded", () => {
  const timelines = document.querySelectorAll(".oma-ritual-timeline");

  if (!("IntersectionObserver" in window)) {
    timelines.forEach((timeline) => timeline.classList.add("is-animated"));
    return;
  }

  const observer = new IntersectionObserver(
    (entries, obs) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) {
          return;
        }

        entry.target.classList.add("is-animated");
        obs.unobserve(entry.target);
      });
    },
    {
      threshold: 0.3,
    },
  );

  timelines.forEach((timeline) => observer.observe(timeline));
});
